import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@onep/ng-uikit-lib/icon';

import * as ɵngcc0 from '@angular/core';
class SpinnerComponent {
    constructor() {
        /**
         * Defines if the component is animated
         */
        this.noAnimation = false;
    }
    ngOnInit() { }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["onep-spinner"]], inputs: { noAnimation: "noAnimation" }, decls: 1, vars: 0, consts: [[1, "onep-spinner"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } } });
SpinnerComponent.ctorParameters = () => [];
SpinnerComponent.propDecorators = {
    noAnimation: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{ selector: 'onep-spinner', template: "<div class=\"onep-spinner\"></div>\n" }]
    }], function () { return []; }, { noAnimation: [{
            type: Input
        }] }); })();

/**
 * Module that provides the spinner component.
 */
class SpinnerModule {
}
SpinnerModule.ɵfac = function SpinnerModule_Factory(t) { return new (t || SpinnerModule)(); };
SpinnerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SpinnerModule });
SpinnerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, IconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerModule, [{
        type: NgModule,
        args: [{
                declarations: [SpinnerComponent],
                imports: [CommonModule, IconModule],
                exports: [SpinnerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SpinnerModule, { declarations: function () { return [SpinnerComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [SpinnerComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SpinnerComponent, SpinnerModule };

